import { render, staticRenderFns } from "./OverseasTrain.vue?vue&type=template&id=00519d9d&"
import script from "./OverseasTrain.vue?vue&type=script&lang=js&"
export * from "./OverseasTrain.vue?vue&type=script&lang=js&"
import style0 from "./OverseasTrain.vue?vue&type=style&index=0&id=00519d9d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports